// FeaturesSection.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

function FeaturesSection() {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });

  const features = [
    { title: '실시간 집중력 시각화', description: '주의력 흐름을 시각화합니다.' },
    { title: '스마트폰 시선 추적', description: '카메라만으로 시선 분석' },
    { title: '객관적 리포트 제공', description: '훈련 리포트를 제공합니다.' },
  ];

  const isMobile = window.innerWidth <= 768;

  return (
    <section
      ref={ref}
      style={{
        height: '100vh',
        scrollSnapAlign: 'start',
        backgroundColor: '#fafafa',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ maxWidth: '960px', width: '90%', textAlign: 'center' }}>
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.6 }}
          style={{ fontSize: isMobile ? '6vw' : '36px', marginBottom: '5vh' }}
        >
          주요 기능
        </motion.h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5vw', alignItems: 'center' }}>
          {features.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ delay: 0.2 + i * 0.2, duration: 0.6 }}
              style={{
                width: '100%',
                maxWidth: '600px',
                padding: isMobile ? '5vw' : '32px',
                backgroundColor: '#fff',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
            >
              <h3 style={{ fontSize: isMobile ? '5vw' : '24px' }}>{f.title}</h3>
              <p style={{ fontSize: isMobile ? '4vw' : '18px' }}>{f.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
